if (!customElements.get('header-component')) {
  customElements.define(
    'header-component',
    class HeaderComponent extends HTMLElement {
      constructor() {
        super();
        this.abortController = new AbortController();
        this.currency = this.getAttribute("currency").split("00")[1];
        this.cache = {}; // Initialize cache object
        document.addEventListener("DOMContentLoaded", () => {
            this.setStickyHeader();
            this.initInputSearchUI();
        });
    }

    initInputSearchUI() {
        let input = this.querySelector(".input_search_container input"),
            container = input.closest(".input_search_container"),
            resultsContainer = this.querySelector(".search_results_container .main_search_results_container");

        input.addEventListener("focus", () => container.classList.add("focused"));
        input.addEventListener("blur", () => container.classList.remove("focused"));
        input.addEventListener("click", () => { input.value = input.value; input.dispatchEvent(new Event("input")); });

        let timeoutId;
        input.addEventListener("input", () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                let searchTerm = input.value.trim();
                if (searchTerm.length > 0) {
                    this.getSearchResults(searchTerm, resultsContainer);
                } else {
                    resultsContainer.parentElement.classList.remove("show");
                }
            }, 300);
        });

   

        let searchWrapper = this.querySelector(".search_wrapper");
        searchWrapper.querySelectorAll(".close_search_bar, .dark_overlay").forEach(elem => {
            elem.addEventListener("click", () => {
                searchWrapper.classList.remove("active");
                document.body.style.overflowY = "auto";
            });
        });

        this.querySelector(".search_icon").addEventListener("click", () => {
            if(searchWrapper.classList.contains("active")){
                searchWrapper.classList.remove("active")
                document.body.style.overflowY = "auto";
            }else{
                searchWrapper.classList.add("active");
                document.body.style.overflowY = "hidden";
            }
   
        });

        document.addEventListener("click", (event) => {
            let searchResults = document.querySelector(".header_menu_container .search_results_container .main_search_results_container");
            if (!searchResults.contains(event.target)) {
                searchResults.parentElement.classList.remove("show");
            }
        });
    }

    async getSearchResults(query, resultsContainer) {
        this.abortController.abort();
        this.abortController = new AbortController();
        const formattedQuery = query.replace(/\s+/g, "-").toLowerCase();
        
        // Check if results are cached
        if (this.cache[formattedQuery]) {
            resultsContainer.innerHTML = this.buildResultsMarkup(this.cache[formattedQuery], query);
            resultsContainer.parentElement.classList.add("show");
            this.initSwiper();
            return; // Exit if cached results are used
        }

        this.querySelector(".search_results_container").classList.add("loading");


        try {
            let response = await fetch(`/search/suggest.json?q=${encodeURIComponent(formattedQuery)}&resources[type]=product,collection&resources[limit]=12&resources[options][unavailable_products]=last`, {
                signal: this.abortController.signal
            });

            if (!response.ok) throw Error(response.status);
            let data = await response.json();
            // Cache the fetched results
            this.cache[formattedQuery] = data;
            let markup = this.buildResultsMarkup(data, query);

            resultsContainer.innerHTML = markup;

            // Show or hide results container based on markup
            if (markup.trim()) {
                resultsContainer.parentElement.classList.add("show");
            } else {
                resultsContainer.parentElement.classList.remove("show");
            }
            this.initSwiper();
        } catch (error) {
            if (error.name !== "AbortError") console.error("Fetch error:", error);
        } finally {
            this.querySelector(".search_results_container").classList.remove("loading");
        }
    }

    buildResultsMarkup(e, s) {
        let t = '<div class="suggestions_search_results">';
        let hasResults = false;
    
        // Handle collections results
        if (e.resources.results.collections && e.resources.results.collections.length > 0) {
            hasResults = true;
            t += '<div class="suggestions_wrapper"><h2 class="title_search_section">Suchvorschläge</h2><div class="links_search_section">';
            e.resources.results.collections.forEach(item => {
                t += `<a href="${item.url}" class="link_search_item custom-collection-class">${item.title}</a>`;
            });
            t += "</div></div>";
        }
    
        // Handle product results
        if (e.resources.results.products.length > 0) {
            hasResults = true;
            t += `
                <div class="products_suggestions_container">
                    <h2 class="title_search_section">Produktvorschläge</h2>
                    <div class="${window.innerWidth >= 1100 ? "swiper mySwiper" : ""} links_search_section">
                        <div class="product-slider ${window.innerWidth < 1100 ? "" : "swiper-wrapper"}">`;
    
            e.resources.results.products.forEach(product => {
                let discountPercentage = product.compare_at_price_min && product.compare_at_price_min > product.price
                    ? Math.round(100 * (product.compare_at_price_min - product.price) / product.compare_at_price_min)
                    : null;
    
                t += `
                <a href="${product.url}" class="link_search_item swiper-slide custom-product-class">
                    ${product.featured_image ? `<img class="product_img_search" src="${product.featured_image.url}" alt="${product.featured_image.alt}">` : ""}
                    <span class="product-title">${product.title}</span>
                    <span class="product__compare-at-price">${parseFloat(product.compare_at_price_min) > 0 ? `${product.compare_at_price_min}${this.currency}` : ""}</span>
                    <div class="product-price__row">
                        <span class="product-price">${product.price}${this.currency}</span>
                        ${discountPercentage !== null ? `<span class="product-discount-percentage">-${discountPercentage}%</span>` : ""}
                    </div>
                </a>`;
            });
    
            t += `</div></div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                    <a class="search-footer__container" href="/search?q=${encodeURIComponent(s)}">
                        <span class="search-footer__text">Weitere Ergebnisse ansehen</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="19" viewBox="0 0 15 19" fill="none">
                        <g filter="url(#filter0_d_5422_11845)">
                          <path d="M5 4.5L10 9.5L5 14.5" stroke="#7B7B7B" />
                        </g>
                        <defs>
                          <filter id="filter0_d_5422_11845" x="0.646423" y="0.146484" width="14.0607" height="18.707" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                            <feOffset dy="4" />
                            <feGaussianBlur stdDeviation="2" />
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5422_11845" />
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5422_11845" result="shape" />
                          </defs>
                        </svg>
                    </a>
                </div>`;
        }
    
        // If no products or collections found, inject message
        if (!hasResults) {
            t += '<div class="no-results-message">Es wurden keine Ergebnisse gefunden.</div>';
        }
    
        t += "</div>";
        return t;
    }
    

    initSwiper() {
        let swiperElement = this.querySelector(".mySwiper");
        if (swiperElement) {
            this.swiper = new Swiper(swiperElement, {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 18,
                navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev")
                }
            });
        }
    }

    setStickyHeader() {
        if (this.getAttribute("header-type") === 'fixed') {
            const bar = document.querySelector('#shopify-section-annoncement-bar-section');
            const header = document.querySelector(`#${this.getAttribute("section-id")}`);
    
            if (bar) {
                bar.style.position = 'sticky';
                bar.style.top = '0';
                bar.style.zIndex = '999';
                header.style.top = `${bar.offsetHeight}px`;
            } else {
                header.style.top = '0px';
            }
    
            header.style.position = 'sticky';
            header.style.zIndex = '99';
            header.style.transition = 'transform 0.3s ease-out'; // Add transition for smooth effect
    
            let lastScrollY = window.scrollY;
    
            window.addEventListener('scroll', () => {
                if (window.scrollY > 350) {
                    // Scrolled down past 200px
                    if (window.scrollY > lastScrollY) {
                        // Scrolling down
                        header.style.transform = 'translateY(-100%)'; // Hide the header
                    } else {
                        // Scrolling up
                        header.style.transform = 'translateY(0)'; // Show the header
                    }
                }
                lastScrollY = window.scrollY; // Update lastScrollY
            });
    
            window.addEventListener('resize', () => {
                if (bar) {
                    header.style.top = `${bar.offsetHeight}px`;
                } else {
                    header.style.top = '0px';
                }
            });
        }
    }
    
    
      
    }
  );
}
